import type { ScoreCompositionRow } from "../types/index.ts";

interface CompositionBarProps {
  rows: ScoreCompositionRow[];
}

const DIMENSION_COLORS: Record<string, string> = {
  Social: "#3b82f6",
  Backers: "#8b5cf6",
  Pedigree: "#f59e0b",
  Momentum: "#10b981",
  Dev: "#06b6d4",
  Revenue: "#ec4899",
};

export function CompositionBar({ rows }: CompositionBarProps) {
  if (rows.length === 0) {
    return <div className="td-chart-empty">No composition data</div>;
  }

  return (
    <div className="td-composition">
      {rows.map((row) => {
        const pct = row.maxPoints > 0 ? (row.avgPoints / row.maxPoints) * 100 : 0;
        const color = DIMENSION_COLORS[row.dimension] ?? "var(--muted)";
        return (
          <div key={row.dimension} className="td-comp-row">
            <span className="td-comp-label">{row.dimension}</span>
            <div className="td-comp-track">
              <div className="td-comp-fill" style={{ width: `${pct}%`, backgroundColor: color }} />
            </div>
            <span className="td-comp-value">{row.avgPoints.toFixed(1)}</span>
            <span className="td-comp-max">/ {row.maxPoints}</span>
          </div>
        );
      })}
    </div>
  );
}
